import { EntityDetailHeader } from '@/components/investigations/entity-detail/EntityDetailHeader'
import { SnippetRows } from '@/components/source-snippets/SnippetRows'
import { SnippetMapping } from './SourceSnippetResult'
import { useSnippetSelection } from './selection'
import { useSourceSnippets } from './useSourceSnippets'

export function SourceSnippetDetail({ caseId, id }: { caseId: string; id: string }) {
  const snippet = useSourceSnippets(caseId).find(item => item.id === id)
  const selected = useSnippetSelection(state => state.selected)
  const focusedRow = selected?.id === id ? selected.row : undefined
  if (!snippet) return null
  return (
    <div className="min-w-0 space-y-3 border-t border-border/40 px-3 py-3">
      <EntityDetailHeader name={snippet.title} typeLabel="SourceSnippet" />
      <SnippetMapping snippet={snippet} />
      <SnippetRows snippet={snippet} focusedRow={focusedRow} />
    </div>
  )
}
